<template>
  <div v-if="value && Object.keys(value).length > 0" :qaid="`store-locator-card__store-${value.id}`">
    <div v-if="value.isMyStore" class="mt-1 lg:ml-2 flex" qaid="store-locator-card__favorite_indicator">
      <i class="material-icons">favorite</i> <span class="ml-1 font-bold">{{ bp('storeFinderYourStore') }}</span>
    </div>
    <div
      class="locator-store-card cursor-pointer"
      :class="{hovered: pinHovered}"
      qaid="store-locator-card__card"
      @click.prevent="storeClicked"
    >
      <div class="media-object">
        <div class="media-object__section sm:hidden md:block">
          <div>
            <img
              :src="storeImage"
              class="w-24 h-auto lazyload"
              qaid="store-locator-card__image"
              @error="usePlaceholder"
            />
          </div>
        </div>
        <div class="media-object__section text-sm">
          <div class="text-md font-bold" qaid="store-locator-card__name" v-html="value.name"></div>
          <p qaid="store-locator-card__address" v-html="value.address"></p>
          <div class="flex">
            <span qaid="store-locator-card__distance">{{ value.distance }}</span>
            <span class="inline-block mx-25">&bull;</span>
            <span
              class="font-bold mr-25"
              qaid="store-locator-card__open-status"
              v-html="storeStatus(value.statusText)"
            ></span>
            <div qaid="store-locator-card__hours">
              <div v-for="(hour, i) in value.statusHours" :key="`hour-${value.id}${i}`">{{ hour }}</div>
            </div>
          </div>
          <pdl-label-group class="mt-1" qaid="store-locator-card-labels">
            <pdl-label v-if="hasBestSelection" kind="positive" qaid="store-locator-best-selection-label">
              <span v-html="bp('storeFinderBestSelection')" />
            </pdl-label>
            <pdl-label v-if="hasSale" kind="prominent" qaid="store-locator-sale-label">
              <span v-html="bp('storeFinderSale')" />
            </pdl-label>
          </pdl-label-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Constants} from '@/components/locator/mixins/constants';
import {PdlLabel, PdlLabelGroup} from '@pedal/pdl-label';

export default {
  name: 'LocatorCard',
  components: {PdlLabel, PdlLabelGroup},
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    pinHovered: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasBestSelection() {
      return !!this.value?.badges?.bestSelection;
    },
    hasSale() {
      return !!this.value?.badges?.sale;
    },

    storeImage() {
      return this.value.thumbnail ?? this.usePlaceholder();
    },
  },
  methods: {
    usePlaceholder(e) {
      if (e && e.target) {
        e.target.src = Constants.storePlaceholder(292, 219);
      } else {
        return Constants.storePlaceholder(292, 219);
      }
    },

    storeClicked() {
      this.$emit('store-clicked', this.value.id, this.value.distance);
    },

    storeStatus(status) {
      if (!status) return null;

      if (status.toLowerCase() == 'closed') {
        return this.bp(status);
      } else {
        return this.bp(`open${status}`);
      }
    },
  },
};
</script>
